import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../auth/ApiMethod";

const normalizePermissionModule = (item = {}) => ({
  moduleID: item.moduleID || item.moduleId || item.id || null,
  moduleName: item.moduleName || item.name || "",
  compareName: item.compareName || "",
  isAssigned: Boolean(item.isAssigned),
});

const normalizeModuleListResponse = (response) => {
  const rows = Array.isArray(response?.responseData?.data)
    ? response.responseData.data.map(normalizePermissionModule)
    : [];

  return {
    ...response,
    totalCount: response?.totalCount || rows.length,
    responseData: {
      ...response?.responseData,
      data: rows,
    },
  };
};

export const GetEmployeeModuleList = async (employeeKeyID) => {
  const response = await getApiWithAuthorization(
    `${Base_Url}api/Permissions/GetEmployeeModuleList?employeeKeyID=${encodeURIComponent(
      employeeKeyID || "",
    )}`,
  );

  if (response?.statusCode === 200) {
    return normalizeModuleListResponse(response);
  }

  return response;
};

export const SaveEmployeeModulePermission = async (params = {}) =>
  postApiWithAuthorization(
    `${Base_Url}api/Permissions/SaveEmployeeModulePermission`,
    {
      employeeKeyID: params.employeeKeyID || null,
      moduleIDs: Array.isArray(params.moduleIDs)
        ? params.moduleIDs.map((item) => Number(item)).filter(Boolean)
        : [],
      userKeyID: params.userKeyID || null,
    },
  );
